export default __webpack_public_path__ + "static/media/industrial-jackets-icon.e377cc19.svg";